'use client';

import { Fragment } from 'react';
import Script from 'next/script';

import { Misc } from '@payload-types';

export function AdminScripts({ scripts }: { scripts: Misc['scripts'] }) {
  if (!scripts || scripts.length < 1) {
    return null;
  }

  return (
    <>
      {scripts.map((i) => (
        <Fragment key={i.id}>
          <Script
            id={`script-from-admin_${i.id}`}
            dangerouslySetInnerHTML={{ __html: i.script }}
            strategy="beforeInteractive"
          />
          {i.noscript && (
            <noscript dangerouslySetInnerHTML={{ __html: i.noscript }} />
          )}
        </Fragment>
      ))}
    </>
  );
}
